import { StatusBadge } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { assertUnreachableOrReturnDefault } from 'src/lib/assertUnreachable';
import { ProposalStatus } from 'src/lib/graphqlTypes/types';

export const ProposalStatusBadge = ({
  status,
  className,
}: {
  status: ProposalStatus;
  className?: string;
}) => {
  switch (status) {
    case ProposalStatus.DRAFT:
      return (
        <StatusBadge
          variant="rounded"
          colorScheme="yellow"
          className={classnames('text-sm font-semibold', className)}
        >
          Draft
        </StatusBadge>
      );
    case ProposalStatus.OPEN:
      return (
        <StatusBadge
          variant="rounded"
          colorScheme="blue"
          className={classnames('text-sm font-semibold', className)}
        >
          Open for feedback
        </StatusBadge>
      );
    case ProposalStatus.APPROVED:
      return (
        <StatusBadge
          variant="rounded"
          colorScheme="green"
          className={classnames('text-sm font-semibold', className)}
        >
          Approved
        </StatusBadge>
      );
    case ProposalStatus.CLOSED:
      return (
        <StatusBadge
          variant="rounded"
          colorScheme="gray"
          className={classnames('text-sm font-semibold', className)}
        >
          Closed
        </StatusBadge>
      );
    case ProposalStatus.IMPLEMENTED:
      return (
        <StatusBadge
          variant="rounded"
          colorScheme="green"
          className={classnames('text-sm font-semibold', className)}
        >
          Implemented
        </StatusBadge>
      );
    default:
      return assertUnreachableOrReturnDefault(
        status,
        <StatusBadge
          variant="rounded"
          colorScheme="gray"
          className={classnames('text-sm font-semibold', className)}
        >
          {status}
        </StatusBadge>,
      );
  }
};
